// src/utils/mediaUtils.js

export const MEDIA_BASE_URL = 'https://prod.getrevibe.app';

/**
 * Resolve a potentially relative media URL to an absolute one.
 */
export const getFullUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return `${MEDIA_BASE_URL}${url}`;
};

/**
 * Pick the best (first "ready") media item from a media array.
 */
export const getBestMedia = (mediaArray) => {
  if (!mediaArray || mediaArray.length === 0) return null;
  return mediaArray.find((m) => m.status === 'ready') || mediaArray[0];
};